var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{ref:"donutChart",staticClass:"custom-donut-chart"})}
var staticRenderFns = []

export { render, staticRenderFns }